import React from 'react'
import { Link } from 'react-router-dom'
import { eventIdToCommunityIndexMapType } from '../../../api/events/helpers'
import { Event } from '../../../models'
import { eventTimeZone, formatTime } from '../../../util/dateTime'
import Routes from '../../../startup/routes'
import TimeZoneLabel from '../misc/TimeZoneLabel'

type Props = { events: Event[]; eventIdToCommunityIndexMap?: eventIdToCommunityIndexMapType }

const EventsListTableItems: React.FC<Props> = ({ events, eventIdToCommunityIndexMap }) => {
  if (events.length === 0) return null

  return (
    <ul
      className="ongoingEvents-container row"
      style={{
        maxHeight: `${events.length * 25}px`,
      }}
    >
      {events.map(event => {
        const communityIndex = eventIdToCommunityIndexMap && eventIdToCommunityIndexMap[event.id]
        return (
          <li key={event.id} className={`ongoingEvent columns small-12 medium-12 large-6 type${communityIndex}-tiny`}>
            <Link to={Routes.event(event, event.community)} className="row">
              <div className="ongoingEvent-field columns small-9 large-8">
                <span className="ongoingEvent-title">{event.title}</span>
                {/*{event.day && ` (${event.day})`}*/}
              </div>
              <div className="ongoingEvent-field columns small-3 large-4">
                {event.allDay ? (
                  'All Day'
                ) : (
                  <>
                    {formatTime(event.startAt, eventTimeZone(event))}
                    {event.endAt && (
                      <span className="show-for-large"> - {formatTime(event.endAt, eventTimeZone(event))}</span>
                    )}
                    <TimeZoneLabel timeZone={eventTimeZone(event)} on={event.startAt} />
                  </>
                )}
              </div>
            </Link>
          </li>
        )
      })}
    </ul>
  )
}

export default EventsListTableItems
